import { LABELS_TYPE, LABELS_CF_TYPE } from '@atlassian/jira-platform-field-config';
import type { FormatRule, EvaluateHandler } from '../../../evaluate-format-rule/types';
import type { TransformedLabelsField } from '../types';

const evaluateHandler: EvaluateHandler<TransformedLabelsField> = {
	CONTAINS: (field, value) =>
		Boolean(
			Array.isArray(value) &&
				field.value?.filter((fieldValue) => fieldValue && value?.includes(fieldValue)).length ===
					value?.length,
		),
	HAS_ANY_OF: (field, value) =>
		Array.isArray(value) &&
		Boolean(field.value?.some((fieldValue) => fieldValue && value?.includes(fieldValue))),
	DOES_NOT_CONTAIN: (field, value) =>
		Boolean(
			Array.isArray(value) &&
				field.value?.filter((fieldValue) => fieldValue && value?.includes(fieldValue)).length !==
					value?.length,
		),
	IS_EMPTY: (field) => field.value?.length === 0,
	IS_NOT_EMPTY: (field) => field.value?.length > 0,
};

const evaluateFormatRule: FormatRule<TransformedLabelsField> = ({ field, operator, value }) => {
	const evaluateHandlerFn = evaluateHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

export const labelsEvaluateFormatRule = {
	[LABELS_TYPE]: evaluateFormatRule,
	[LABELS_CF_TYPE]: evaluateFormatRule,
};
